<ul class="c-vloket-icon-list">
	@for (item of items; track item) {
		<li class="c-vloket-text c-vloket-text--lg c-vloket-icon-list__item">
			<fa-icon
				class="c-vloket-icon-list__item__icon c-vloket-icon-list__item__icon--{{ item.iconClass }}"
				[icon]="item.icon"
				[iconType]="item.iconType"
				[alt]="item.alt"
			/>
			<div class="c-vloket-icon-list__content" [ngClass]="{ 'c-vloket-icon-list__no-link': !item?.to }">
				@if (item?.to) {
					<cjm-link
						classes="c-vloket-icon-list__link c-vloket-icon-list__content"
						[to]="item.to"
						[fragment]="item.fragment"
						[title]="item.text"
					>
						{{ item.text }}
					</cjm-link>
				} @else {
					{{ item.text }}
				}
			</div>
		</li>
	}
</ul>
